export const getStorage = (key: string, defaultValue: any) => {
  const value = localStorage.getItem(key);

  try {
    return value !== null ? JSON.parse(value) : defaultValue;
  } catch {
    return value !== null ? value : defaultValue; // Jika bukan JSON, kembalikan sebagai string biasa
  }
};

export const setStorage = (key: string, value: any) => {
  if (typeof value === "string") {
    localStorage.setItem(key, value); // Jika string, simpan langsung
  } else {
    localStorage.setItem(key, JSON.stringify(value)); // Jika bukan string, simpan sebagai JSON
  }
};
